import Services from "../components/Services";
import Networking from "../components/Networking";
import WhyUs from "../components/WhyUs";

export default function ServicesPage() {
  return (
    <div className="pt-24 sm:pt-28">
      <Services />
      <Networking />
      <WhyUs />
    </div>
  );
}
